import { RetailerNetworkTobaccoProgramMetricType } from '@occc/graphql';

import { LocationRankingTable } from './location-ranking-table.component';

import { LocationRankingFilterValues, useLocationRanking } from '../../hooks/use-location-ranking';

export type LocationRankingMetric = {
  type: RetailerNetworkTobaccoProgramMetricType;
  label: string;
};

type LocationRankingTableContainerProps = Pick<
  LocationRankingFilterValues,
  'dateFrom' | 'dateTo'
> & {
  metric: LocationRankingMetric;
  retailerNetworkUuid: string;
};

export const LocationRankingTableContainer = (props: LocationRankingTableContainerProps) => {
  const { dateFrom, dateTo, retailerNetworkUuid, metric } = props;
  const locationRanking = useLocationRanking({
    dateFrom,
    dateTo,
    retailerNetworkUuid,
    metricType: metric.type,
  });

  return (
    <LocationRankingTable
      onSearchSubmit={locationRanking.onSearchSubmit}
      data={locationRanking.data}
      loading={locationRanking.loading}
      error={locationRanking.error}
      valueLabel={metric.label}
      paginationProps={locationRanking.paginationProps}
    />
  );
};
